<div class="breadcrumb--top"></div>
<div class="inner-container clearfix"
    id="skip-main-content"
    role="main">
    <div class="bolt-container">
        <h1 id="heading">Unable to process request</h1>
        <div class="bolt-space-bottom-lg">
            <bolt-notification>
                We were unable to process your request due to a system error. Please try again later.
            </bolt-notification>
        </div>
        <div class="button-spacing pull-right">
            <bolt-button (click)="callNationwide()">Go to Nationwide.com</bolt-button>
        </div>
    </div>
</div>
